module.exports = __webpack_public_path__ + "static/img/01.9af0acc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour3/01.jpg
// module id = XnDi
// module chunks = 0